export default __webpack_public_path__ + "static/media/eye-off.76f91858.svg";